import { CHECKWORK_WSPOS, CHECKWORK_WSPOS_SUCCESSFUL, CHECKWORK_WSPOS_FAILED } from './actionTypes';

const initialState = {
    checkWorkWSPositionError: null, messageCheckWorkWSPosition: null, loadingCheckWorkWSPosition: false
}

const checkWorkWSPosition = (state = initialState, action) => {
    switch (action.type) {
        case CHECKWORK_WSPOS:
            state = {
                ...state,
                loadingCheckWorkWSPosition: true,
                checkWorkWSPositionError: null
            }
            break;
        case CHECKWORK_WSPOS_SUCCESSFUL:
            state = {
                ...state,
                loadingCheckWorkWSPosition: false,
                messageCheckWorkWSPosition: action.payload,
                checkWorkWSPositionError: null
            }
            break;
        case CHECKWORK_WSPOS_FAILED:
            state = {
                ...state,
                messageUnlockWSPosition: null,
                loadingCheckWorkWSPosition: false,
                checkWorkWSPositionError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default checkWorkWSPosition;